<template>
  <div class="filter-bar ui basic segment grid">
    <div class="ui form">
      <div class="inline field">
        <h6 class="heading-small text-muted mb-4">Search</h6>
        <div class="input-group mb-3">
          <input type="text" class="form-control" :placeholder="placeholder" @keyup.enter="doFilter"
            v-model="filterText">
          <div class="input-group-append">
            <base-dropdown v-model="searchFilter">
              <base-button slot="title" type="secondary"
                class="btn-outline-primary dropdown-toggle dropdown-toggle-split"
                style="border-top-left-radius: 0px;border-bottom-left-radius: 0px; height: 35px!important;" />
              <a class="dropdown-item" @click.prevent="changeSearchFilter('name')" v-if="(currentProfile != 'gift_certificates')">Name</a>
              <a class="dropdown-item" v-if="(currentProfile != 'users')"
                @click.prevent="changeSearchFilter('code')">Code</a>
              <!-- <a class="dropdown-item" @click.prevent="changeSearchFilter('refcode')">Reference Code</a> -->
              <!-- <a class="dropdown-item" v-if="(currentProfile == 'reasons')" @click.prevent="changeSearchFilter('reason_type')">Reason Type</a> -->
              </base-dropdown>
          </div>
        </div>

        <base-input v-if="(currentProfile == 'reason_types')" label="Operation">
          <select class="form-control" v-model="operation" @change="doFilter()" size="large">
            <option v-for="option in operationOptions" v-bind:value="option.key" v-bind:key="option.key">
              {{ option.value }}
            </option>
          </select>
        </base-input>

        <hr class="my-4" />
        <h6 class="heading-small text-muted mb-4">Filter by status</h6>
        <div v-if="currentProfile == 'gift_certificates'">
          <base-radio name="0" class="mb-3" v-model="filterStatus" value="O">
            All
          </base-radio>
          <base-radio name="C" class="mb-3" v-model="filterStatus" value="C">
            Created
          </base-radio>
          <base-radio name="A" class="mb-3" v-model="filterStatus" value="A">
            Activated
          </base-radio>
          <base-radio name="I" class="mb-3" v-model="filterStatus" value="I">
            Inactive
          </base-radio>
          <base-radio name="U" class="mb-3" v-model="filterStatus" value="U">
            Used
          </base-radio>
          <base-radio name="S" class="mb-3" v-model="filterStatus" value="S">
            Sold
          </base-radio>
          <base-radio name="V" class="mb-3" v-model="filterStatus" value="V">
            Voided
          </base-radio>
        </div>
        <div v-else>
          <base-radio name="0" class="mb-3" v-model="filterStatus" value="O">
            All
          </base-radio>
          <base-radio name="A" class="mb-3" v-model="filterStatus" value="A">
            Active
          </base-radio>
          <base-radio name="I" class="mb-3" v-model="filterStatus" value="I">
            Inactive
          </base-radio>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    computed: {
      ...mapState(['currentProfile']),
    },
    data: function () {
      return {
        filterText: '',
        searchFilter: "name",
        placeholder: "Search by Name",
        filterStatus: '0',
        operation: '',
        operationOptions: [
          { value: "ALL", key: ""},
          {value: "ABORT RECEIPT", key: "ABT"},
          {value: "ITEM DISCOUNT", key: "DSC"},
          {value: "LINE VOID", key: "LVD"},
          {value: "VOID RECEIPT", key: "VOI"},
          {value: "PRICE OVERRIDE", key: "OVD"},
          {value: "TRANSACTIONAL PRICE CHANGE", key: "PLC"},
          {value: "REPRINT OF RECEIPT", key: "PRN"},
          {value: "RETURN", key: "RET"},
          {value: "TAX CHANGE", key: "TAX"},
          {value: "BARCODE PRINTING", key: "BCD"},
          {value: "WITHDRAWAL", key: "WIT"},
          {value: "DEPOSIT", key: "DEP"}
        ]
      }
    },
    mounted: async function () {
      this.placeholder = (this.currentProfile == 'gift_certificates') ? "Search by Code" : "Search by Name";
    },
    watch: {
      filterStatus: function () {
        // eslint-disable-next-line
        // console.log(this.filterStatus)
        // changeFilter(statusFilter, searchFilter, searchText)
        let filterText = this.filterText
        if(this.currentProfile == 'reason_types' && this.operation != ""){
          filterText = filterText + "&" + "operation_type=" + this.operation
        }
        this.$emit('changeFilter', this.filterStatus, this.searchFilter, filterText)
      }
    },
    methods: {
      changeSearchFilter(searchFilter) {
        this.searchFilter = searchFilter
        if (searchFilter == "operation_type") {
          this.placeholder = "Search by operation"
        } else {
          this.placeholder = "Search by " + searchFilter
        }
      },
      doFilter() {
        let filterText = this.filterText
        if(this.currentProfile == 'reason_types' && this.operation != ""){
          filterText = filterText + "&" + "operation_type=" + this.operation
        }
        this.$emit('changeFilter', this.filterStatus, this.searchFilter, filterText)
      }
    }
  }
</script>